import { Flex } from 'foundations-components/components/Flex';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { useFilterConfig } from '../hooks/useFilterConfig';
import { LanguageFilter } from './reusableFilters/LanguageFilter';
import { SelectFilter } from './reusableFilters/SelectFilter';
import { ToggleFilter } from './reusableFilters/ToggleFilter';
import { SyncDirectionFilter } from './singleUseFilters/SyncDirectionFilter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function AppFilterControls() {
  const {
    AppLanguages,
    BuiltByHubspot,
    Category,
    Certified,
    HubspotFeatures,
    PricingPlan,
    SupportLanguages,
    ToolIntegrations
  } = useFilterConfig();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SelectFilter, {
      filter: PricingPlan
    }), /*#__PURE__*/_jsx(SelectFilter, {
      filter: Category,
      multi: true
    }), /*#__PURE__*/_jsx(SelectFilter, {
      filter: HubspotFeatures,
      multi: true
    }), /*#__PURE__*/_jsx(SelectFilter, {
      filter: ToolIntegrations,
      multi: true,
      virtualized: true
    }), /*#__PURE__*/_jsx(SelectFilter, {
      filter: BuiltByHubspot
    }), Certified && /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      marginBlockStart: "400",
      children: [/*#__PURE__*/_jsx(FormLabel, {
        htmlFor: Certified.fieldWithEcoPrefix,
        children: Certified.label
      }), /*#__PURE__*/_jsx(ToggleFilter, {
        filter: Certified
      })]
    }), /*#__PURE__*/_jsx(SyncDirectionFilter, {}), /*#__PURE__*/_jsx(LanguageFilter, {
      filter: AppLanguages
    }), /*#__PURE__*/_jsx(LanguageFilter, {
      filter: SupportLanguages
    })]
  });
}